import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: { defaultMessage: 'Deposit {currencySymbol}' },

  firstInfoValueTitle: { defaultMessage: 'Your balance' },
  secondInfoValueTitle: { defaultMessage: 'Your wallet balance' },
  graphDotName: { defaultMessage: 'APY' },
});
